import { useEffect, useRef } from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { getVenueBySlug } from "@/data/linkTreeVenues";
import { trackEvent } from "@/lib/amplitude";
import LinkTreeCard from "@/components/linkTree/LinkTreeCard";

const FONT_HREF =
  "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;700&display=swap";

export default function LinkTreeLanding() {
  const { slug } = useParams<{ slug: string }>();
  const [searchParams] = useSearchParams();
  const isTag = searchParams.get("isTag") === "true";
  const hasTrackedView = useRef(false);

  const venue = slug ? getVenueBySlug(slug) : undefined;

  const waiterIdRaw = searchParams.get("w");
  const waiterId =
    waiterIdRaw !== null && /^\d+$/.test(waiterIdRaw) ? parseInt(waiterIdRaw, 10) : null;

  useEffect(() => {
    if (venue && !hasTrackedView.current) {
      hasTrackedView.current = true;
      trackEvent("landing_page_view", {
        venue_slug: venue.slug,
        venue_name: venue.name,
        source: isTag ? "qr_nfc" : "direct",
        waiter_id: waiterId,
      });
    }
  }, [venue, isTag]);

  if (!venue) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link rel="stylesheet" href={FONT_HREF} />

      <div
        className="flex min-h-dvh justify-center"
        style={{
          background: "linear-gradient(180deg, #f4e7dc 0%, #ecdac9 40%, #f0e0d0 100%)",
        }}
      >
        <div className="flex min-h-dvh w-full max-w-[480px] flex-col">
          <div className="flex-1">
            <LinkTreeCard venue={venue} isTag={isTag} waiterId={waiterId} />
          </div>
          <a
            href="https://www.bestiebite.it"
            target="_blank"
            rel="noopener noreferrer"
            className="block pb-6 text-center text-[11px] tracking-wide text-stone-400 transition-colors hover:text-stone-600"
          >
            Powered by Bestie Bite
          </a>
        </div>
      </div>
    </>
  );
}
